module.exports = __webpack_public_path__ + "static/jack-dorsey-eedb816c351a909eff0bced527fbda0b.jpg";